import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const partnerRouter: Array<RouteRecordRaw> = [
    {
        path: '/partner',
        name: '渠道管理',
        component: Layout,
        redirect: '/partner/index',
        meta: { title: '渠道管理', icon: 'icon-partner', alwaysShow: true },
        children: [
            {
                path: 'index',
                name: '渠道首页',
                component: () => import('@/views/partner/Index.vue'),
                meta: { title: '渠道首页', keepAlive: true }
            },
            {
                path: 'order-list',
                name: '订单列表',
                component: () => import('@/views/partner/OrderList.vue'),
                meta: { title: '订单列表' ,keepAlive: true, depth: 30}
            },
            {
                path: 'order-detail',
                name: '订单详情',
                component: () => import('@/views/partner/OrderDetail.vue'),
                meta: { title: '订单详情' }
            },
            {
                path: 'prevpay-list',
                name: '预付款明细',
                component: () => import('@/views/partner/PrevPayList.vue'),
                meta: { title: '预付款明细' ,keepAlive: true, depth: 30}
            },
            {
                path: 'recharge-list',
                name: '充值列表',
                component: () => import('@/views/partner/RechargeList.vue'),
                meta: { title: '充值列表' ,keepAlive: true, depth: 30}
            },
            {
                path: 'recharge-info',
                name: '充值详情',
                component: () => import('@/views/partner/RechargeInfo.vue'),
                meta: { title: '充值详情' }
            },
            {
                path: 'rechargeTotal-list',
                name: '充值统计',
                component: () => import('@/views/partner/RechargeTotalList.vue'),
                meta: { title: '充值统计', keepAlive: true, depth: 30 }
            },
            {
                path: 'rechargeTotal-info',
                name: '充值统计详情',
                component: () => import('@/views/partner/RechargeTotalInfo.vue'),
                meta: { title: '充值统计详情' }
            },
            {
                path: 'consumeTotal-info',
                name: '消费统计详情',
                component: () => import('@/views/partner/consumeTotalInfo.vue'),
                meta: { title: '消费统计详情' }
            },
            {
                path: 'orderListCysh',
                name: '彩洋生活订单核算',
                component: () => import('@/views/partner/OrderListCysh.vue'),
                meta: { title: '彩洋生活订单核算' }
            },
            {
                path: 'check-account',
                name: '渠道对账',
                component: () => import('@/views/partner/AccountList.vue'),
                meta: { title: '渠道对账' }
            },
            {
                path: 'channel-level',
                name: '渠道分级',
                component: () => import('@/views/partner/ChannelLevel.vue'),
                meta: { title: '渠道分级' }
            },
            {
                path: 'develop',
                name: '开发设置',
                component: () => import('@/views/partner/Develop.vue'),
                meta: { title: '开发设置' }
            },
            {
                path: 'prepay-list',
                name: '预付款列表',
                component: () => import('@/views/partner/PrepayList.vue'),
                meta: { title: '预付款' }
            },
            {
                path: 'prepay-edit',
                name: '预付款编辑',
                component: () => import('@/views/partner/PrepayEdit.vue'),
                meta: { title: '预付款编辑' }
            },
            {
                path: 'out-list',
                name: '对外渠道拆分',
                component: () => import('@/views/channel/List.vue'),
                meta: { title: '对外渠道', keepAlive: true, depth: 30 }
            },
            {
                path: 'poster',
                name: '渠道海报',
                component: () => import('@/views/partner/Poster.vue'),
                meta: { title: '渠道海报' }
            },
            {
                path: 'account_power',
                name: '渠道账号权限',
                component: () => import('@/views/partner/UserPowerList.vue'),
                meta: { title: '渠道账号权限' }
            },
            {
                path: 'user_power',
                name: '用户账号权限',
                component: () => import('@/views/partner/AccountPowerList.vue'),
                meta: { title: '用户账号权限' }
            },
            {
                path: 'user-recharge',
                name: '用户充值',
                component: () => import('@/views/partner/UserRecharge.vue'),
                meta: { title: '用户充值' }
            },
        ]
    }
]

export default partnerRouter